var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-divider',{staticClass:"divider-carts mt-3",attrs:{"content-position":"left"}},[_vm._v("Источник")]),_c('v-chart',{staticClass:"chart-e",attrs:{"option":_vm.option,"autoresize":"","social_chart":_vm.social_chart}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }